
<script>
   import { fade, fly } from 'svelte/transition';

   import { onMount } from "svelte";

   onMount(() => window.scrollTo(0,0));

</script>

<div in:fly={{ y : -100, duration : 500 }}>
   <slot></slot>
</div>
